import styled from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ParentCategory = styled(CustomLink)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  padding: 7.5px 0;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};

    & path {
      fill: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const ParentCategoryLoader = styled.div`
  padding: 7.5px 0;
`;

export const CurrentCategory = styled(Typography.Title).attrs<{
  $isCompact?: boolean;
}>({
  $variant: '4',
})`
  font-size: 15px;
  padding: ${({ $isCompact }) =>
    $isCompact ? '10px 15px 10px 0' : '10px 15px'};
`;

export const CurrentCategoryLoader = styled.div<{ $isCompact?: boolean }>`
  padding: ${({ $isCompact }) =>
    $isCompact ? '10px 15px 10px 0' : '10px 15px'};
`;

export const Category = styled(ParentCategory)<{ $isCompact?: boolean }>`
  padding-left: ${({ $isCompact }) => ($isCompact ? '15px' : '30px')};
`;

export const CategoryLoader = styled(ParentCategoryLoader)<{
  $isCompact?: boolean;
}>`
  padding-left: ${({ $isCompact }) => ($isCompact ? '15px' : '30px')};
`;
